var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      staticClass: "d-flex flex-column az-gap-small",
      attrs: { "data-test": "painel-secao-contexto" }
    },
    [
      _c(
        "h3",
        {
          staticClass: "az-text-primary az-size-14 font-weight-medium ma-0 mb-1"
        },
        [_vm._v(_vm._s(_vm.copy.CONTEXTO))]
      ),
      _c(
        "dl",
        { staticClass: "d-flex flex-column ma-0 painel-secao-contexto__lista" },
        [
          _c(
            "div",
            {
              staticClass:
                "painel-secao-contexto__linha d-flex align-baseline az-gap-small"
            },
            [
              _c(
                "dt",
                {
                  staticClass:
                    "painel-secao-contexto__chave ia-sidebar-aux flex-shrink-0"
                },
                [_vm._v(_vm._s(_vm.copy.CLIENTE))]
              ),
              _c(
                "dd",
                {
                  staticClass: "az-text-primary az-size-12 text-truncate ma-0",
                  attrs: {
                    title: _vm.contexto.cliente,
                    "data-test": "painel-secao-contexto-cliente"
                  }
                },
                [_vm._v(_vm._s(_vm.contexto.cliente))]
              )
            ]
          ),
          _vm.agentes
            ? _c(
                "div",
                {
                  staticClass:
                    "painel-secao-contexto__linha d-flex align-baseline az-gap-small"
                },
                [
                  _c(
                    "dt",
                    {
                      staticClass:
                        "painel-secao-contexto__chave ia-sidebar-aux flex-shrink-0"
                    },
                    [_vm._v(_vm._s(_vm.copy.AGENTE))]
                  ),
                  _c(
                    "dd",
                    {
                      staticClass:
                        "az-text-primary az-size-12 text-truncate ma-0",
                      attrs: {
                        title: _vm.agentes,
                        "data-test": "painel-secao-contexto-agentes"
                      }
                    },
                    [_vm._v(_vm._s(_vm.agentes))]
                  )
                ]
              )
            : _vm._e(),
          _vm.fontes.length
            ? _c(
                "div",
                {
                  staticClass:
                    "painel-secao-contexto__linha d-flex align-start az-gap-small"
                },
                [
                  _c(
                    "dt",
                    {
                      staticClass:
                        "painel-secao-contexto__chave ia-sidebar-aux flex-shrink-0 pt-1"
                    },
                    [_vm._v(_vm._s(_vm.copy.FONTES))]
                  ),
                  _c(
                    "dd",
                    {
                      ref: "linhaDeFontes",
                      staticClass:
                        "painel-secao-contexto__fontes d-flex flex-nowrap az-gap-xsmall ma-0",
                      attrs: { "data-test": "painel-secao-contexto-fontes" }
                    },
                    [
                      _vm._l(_vm.fontesVisiveis, function(fonte) {
                        return _c(
                          "span",
                          {
                            key: fonte.tabela,
                            staticClass:
                              "painel-secao-contexto__pilula d-inline-flex align-center az-gap-xsmall",
                            attrs: {
                              title: fonte.rotulo,
                              "data-test": "painel-secao-contexto-fonte"
                            }
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "painel-secao-contexto__rotulo az-text-primary az-size-12 text-truncate"
                              },
                              [_vm._v(_vm._s(fonte.rotulo))]
                            ),
                            _c(
                              "span",
                              { staticClass: "ia-sidebar-aux flex-shrink-0" },
                              [_vm._v(_vm._s(fonte.registros))]
                            )
                          ]
                        )
                      }),
                      _vm.maisFontes
                        ? _c(
                            "span",
                            {
                              staticClass:
                                "painel-secao-contexto__pilula ia-sidebar-aux d-inline-flex align-center flex-shrink-0",
                              attrs: {
                                "data-test": "painel-secao-contexto-mais-fontes"
                              }
                            },
                            [_vm._v(_vm._s(_vm.maisFontes))]
                          )
                        : _vm._e(),
                      _c(
                        "span",
                        {
                          ref: "medidor",
                          staticClass:
                            "painel-secao-contexto__medidor d-flex az-gap-xsmall",
                          attrs: { "aria-hidden": "true" }
                        },
                        [
                          _vm._l(_vm.fontesFormatadas, function(fonte) {
                            return _c(
                              "span",
                              {
                                key: fonte.tabela,
                                staticClass:
                                  "painel-secao-contexto__pilula d-inline-flex align-center az-gap-xsmall",
                                attrs: { "data-medida": "pilula" }
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "az-text-primary az-size-12" },
                                  [_vm._v(_vm._s(fonte.rotulo))]
                                ),
                                _c("span", { staticClass: "ia-sidebar-aux" }, [
                                  _vm._v(_vm._s(fonte.registros))
                                ])
                              ]
                            )
                          }),
                          _c(
                            "span",
                            {
                              staticClass:
                                "painel-secao-contexto__pilula ia-sidebar-aux d-inline-flex",
                              attrs: { "data-medida": "mais" }
                            },
                            [_vm._v(_vm._s(_vm.maiorMaisFontes))]
                          )
                        ],
                        2
                      )
                    ],
                    2
                  )
                ]
              )
            : _vm._e()
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }